const OurStory = () => {
    return (
        <>
        <div className="row align-items-center">
            <div className="col-md-4">
                <div className="about_us_img mb-4 mb-md-0">
                    <img src="/assets/img/contact-us.webp" alt="contact-us" className="img-fluid" />
                </div>
            </div>
            <div className="col-md-8 ps-md-5">
                <p>Lifeline Tulasi Hospital began its healthcare journey in 1997, founded by Dr. J.S. Rajkumar and Dr. Chitrakala Rajkumar, in memory of the late Dr. Rajarathnam, under the mentorship of Dr. Sankaran. Formerly known as RIGID Hospital, Lifeline has been delivering expert medical and surgical care for the past 28 years, dedicated to exemplary treatment that ensures the overall wellbeing of the community.</p>
                <p>Over the years, Lifeline Tulasi Hospital has grown into a 100-bed tertiary care facility in the heart of Hyderabad, equipped with state-of-the-art technology and staffed by a team of highly skilled and experienced doctors. In line with our vision to extend quality healthcare to more communities, we have also launched Lifeline Tulasi Multispeciality Hospital in Hyderabad — now one of the largest hospitals in East Hyderabad.</p>
                <p>We continue to provide the latest in healthcare at affordable costs, upholding our unwavering commitment to excellence.</p>
            </div>
        </div>
        </>
    );
};

export default OurStory;
